import React from 'react';
import Header from '../header/Header';
import '../components/PrivacyPolicy.css'; // Reusing the premium glass styles

const CookiePolicy = () => {
    return (
        <div>
            <Header />
            <div className="privacy-container">
                <div className="privacy-glass-card">
                    <h1>Cookie Policy</h1>
                    <p style={{ color: '#ccc', fontStyle: 'italic', marginBottom: '20px' }}>Last updated: March 18, 2026</p>
                    
                    <p>This Cookie Policy explains what cookies are and how we use them on the <strong>Tape Signal</strong> platform. You should read this policy to understand what kinds of cookies we deploy, how we use the information collected from them, and how you can control your preferences.</p>

                    <h3 style={{ color: 'white', marginTop: '20px' }}>What are Cookies?</h3>
                    <p>Cookies are small text files that are used to store small pieces of information. They are stored on your device when the website is loaded on your browser. These cookies help us make the website function properly, make it more secure, provide better user experience, and understand how the website performs.</p>

                    <h3 style={{ color: 'white', marginTop: '20px' }}>Types of Cookies We Use</h3>
                    
                    <h4 style={{ color: 'white' }}>1. Strictly Necessary Cookies</h4>
                    <p>These cookies are essential for you to browse the website and use its features, such as accessing secure areas of the site (e.g., logging into your Tape Signal Account to retrieve plugin licenses). Without these cookies, services like shopping baskets and account dashboards cannot be provided.</p>

                    <h4 style={{ color: 'white' }}>2. Performance & Analytics Cookies</h4>
                    <p>We use third-party services like <strong>Google Analytics</strong> to understand how users interact with our website. These cookies track information such as the number of visitors, bounce rates, and traffic sources, helping us improve the user flow to our hardware plugins. This data is collected anonymously unless you specifically consent.</p>

                    <h4 style={{ color: 'white' }}>3. Marketing & Tracking Cookies</h4>
                    <p>Tape Signal occasionally utilizes tracking technology like the <strong>Facebook Pixel</strong> to analyze the success of our advertising campaigns and deliver targeted promotions for our upcoming audio plugins. These cookies track visitors across websites to collect data to provide customized ads. These cookies are <strong>optional</strong> and will not be deployed if you select 'Decline Optional' in our site's Cookie Banner.</p>

                    <h3 style={{ color: 'white', marginTop: '20px' }}>Managing Your Consent</h3>
                    <p>You can adjust your cookie preferences at any time by clearing your browser's local storage or cookies, which will prompt the Tape Signal consent banner to reappear. You can also block third-party cookies directly through your browser's security settings.</p>

                </div>
            </div>
        </div>
    );
}

export default CookiePolicy;
